/**
 * SearchClearButton
 * -----------------
 * Petit bouton "x" positionné en absolute à droite d'un champ de
 * recherche. Ne s'affiche que si `value` est non-vide. Réinitialise
 * la valeur via `onClear`.
 *
 * Utilisation :
 *   <div className="relative">
 *     <Search className="absolute left-3 …" />
 *     <input value={q} onChange={…} className="pl-8 pr-8 …" />
 *     <SearchClearButton value={q} onClear={() => setQ("")}
 *                        data-testid="docs-search-clear" />
 *   </div>
 *
 * Spec 2026-02-XX (batch amélioration UX) : cohérence globale des
 * champs de recherche à travers l'application.
 */
import { X } from "lucide-react";

export default function SearchClearButton({ value, onClear, className = "", size = 12, testid }) {
  if (!value) return null;
  return (
    <button
      type="button"
      onClick={onClear}
      className={`absolute right-2 top-1/2 -translate-y-1/2 flex items-center justify-center rounded-full bg-transparent border-0 cursor-pointer text-muted-foreground hover:text-white transition-colors ${className}`}
      aria-label="Effacer la recherche"
      title="Effacer la recherche"
      data-testid={testid}
      style={{ padding: 2 }}
    >
      <X size={size} />
    </button>
  );
}
